<template>
  <div class="race-wrapper">
    <div class="race-top"></div>
    <div class="race-content">
      <div class="race-item">
        <div class="race-item-title">获奖名单</div>
        <div class="race-item-title-top">
          <span style="font-weight: 700">"Star of Outlook"</span>
          知心慧学杯英语作文大赛已经圆满结束啦，本次大赛共产生92个获奖名额，应用文写作板块和读后续写板块各46位同学入围，恭喜以下获奖同学！愿各位同学前程似锦！未来可期！
        </div>
        <div class="race-item-title-mhk">应用作文写作（第一名）获奖名单</div>
        <div class="race-item-text">
          <table
            class="tab-mhk"
            border="1"
            align="center"
            width="50%"
            cellspacing="0"
          >
            <tr>
              <td>等第</td>
              <td>学生</td>
              <td>学校名称</td>
            </tr>
            <tr>
              <td>一等奖</td>
              <td>申家兴</td>
              <td>阳泉市第十五中学校</td>
            </tr>
            <tr>
              <td rowspan="10">二等奖</td>
              <td>葛慧玲</td>
              <td>阳泉市第十一中学校</td>
            </tr>
            <tr>
              <td>李子浩</td>
              <td>潍坊文昌中学</td>
            </tr>
            <tr>
              <td>张馨予</td>
              <td>宝清县第一高级中</td>
            </tr>
            <tr>
              <td>郭晴儿</td>
              <td>阳泉市第十五中学校</td>
            </tr>
            <tr>
              <td>付则玮</td>
              <td>福建省宁化第一中学</td>
            </tr>
            <tr>
              <td>韩泽坤</td>
              <td>山西省汾阳中学校</td>
            </tr>
            <tr>
              <td>赵秒</td>
              <td>佛山市顺德区李兆基中学</td>
            </tr>
            <tr>
              <!-- <td>一等奖</td> -->
              <td>徐家根</td>
              <td>万安县崇文中学</td>
            </tr>
            <tr>
              <!-- <td>一等奖</td> -->
              <td>何子焓</td>
              <td>甘肃省礼县第一中学</td>
            </tr>
            <tr>
              <!-- <td>一等奖</td> -->
              <td>胡瑛娜</td>
              <td>黑河市第一中学</td>
            </tr>
            <tr>
              <td rowspan="15">三等奖</td>
              <td>荚靖文</td>
              <td>福建省清流县第一中学</td>
            </tr>
            <tr>
              <td>王诺</td>
              <td>东平高级中学</td>
            </tr>
            <tr>
              <td>李锦弈</td>
              <td>东平高级中学</td>
            </tr>
            <tr>
              <td>尚亦佳</td>
              <td>东平高级中学</td>
            </tr>
            <tr>
              <td>温键宜</td>
              <td>佛山市顺德区李兆基中学</td>
            </tr>
            <tr>
              <td>曾苹</td>
              <td>东平高级中学</td>
            </tr>
            <tr>
              <td>刘晓倩</td>
              <td>山西省汾阳中学校</td>
            </tr>
            <tr>
              <td>宫佳婧</td>
              <td>甘肃省礼县第一中学</td>
            </tr>
            <tr>
              <td>金姝琦</td>
              <td>华亭县第一中学</td>
            </tr>
            <tr>
              <td>张睿</td>
              <td>东平高级中学</td>
            </tr>
            <tr>
              <td>何芳霞</td>
              <td>甘肃省礼县第一中学</td>
            </tr>
            <tr>
              <td>何潼铟</td>
              <td>佛山市顺德区李兆基中学</td>
            </tr>
            <tr>
              <td>冯昊杰</td>
              <td>山西省汾阳中学校</td>
            </tr>
            <tr>
              <td>刁炳桓</td>
              <td>宝清县第一高级中</td>
            </tr>
            <tr>
              <td>马悦</td>
              <td>北方民族大学附属中学</td>
            </tr>
            <tr>
              <td rowspan="20">四等奖</td>
              <td>蒋诗博</td>
              <td>玉门油田第一中学</td>
            </tr>
            <tr>
              <td>张一涵</td>
              <td>山西省汾阳中学校</td>
            </tr>
            <tr>
              <td>安康</td>
              <td>东平高级中学</td>
            </tr>
            <tr>
              <td>饶菡</td>
              <td>山西省汾阳中学校</td>
            </tr>
            <tr>
              <td>刘嘉欣</td>
              <td>佛山市顺德区李兆基中学</td>
            </tr>
            <tr>
              <td>黄翔宇</td>
              <td>东莞外国语学校</td>
            </tr>
            <tr>
              <td>黄金烨</td>
              <td>龙江县第一中学</td>
            </tr>
            <tr>
              <td>曹可心</td>
              <td>宝清县第一高级中</td>
            </tr>
            <tr>
              <td>朱柯桦</td>
              <td>阳泉市第十一中学校</td>
            </tr>
            <tr>
              <td>刘凤怡</td>
              <td>宝清县第二高级中学</td>
            </tr>
            <tr>
              <td>陈佳萍</td>
              <td>梅州市曾宪梓中学</td>
            </tr>
            <tr>
              <td>张梓跃</td>
              <td>阳泉市第十一中学校</td>
            </tr>
            <tr>
              <td>谢金秀</td>
              <td>佛山市顺德区李兆基中学</td>
            </tr>
            <tr>
              <td>邹旭洁</td>
              <td>福建省清流县第一中学</td>
            </tr>
            <tr>
              <td>常瑞婷</td>
              <td>山西省汾阳中学校</td>
            </tr>
            <tr>
              <td>刘烨</td>
              <td>东平高级中学</td>
            </tr>
            <tr>
              <td>高岩岩</td>
              <td>甘肃省合水县第一中学</td>
            </tr>
            <tr>
              <td>陈雅萱</td>
              <td>福建省清流县第一中学</td>
            </tr>
            <tr>
              <td>武嘉旭</td>
              <td>中阳县第一中学校</td>
            </tr>
            <tr>
              <td>张家硕</td>
              <td>宝清县第二高级中学</td>
            </tr>
          </table>
        </div>
        <div class="race-item-title-mhk">读后续写（第二题）获奖名单</div>
        <div class="race-item-text">
          <table
            class="tab-mhk"
            border="1"
            align="center"
            width="50%"
            cellspacing="0"
          >
            <tr>
              <td>等第</td>
              <td>学生</td>
              <td>学校名称</td>
            </tr>
            <tr>
              <td>一等奖</td>
              <td>王思佳</td>
              <td>福建省清流县第一中学</td>
            </tr>
            <tr>
              <td rowspan="10">二等奖</td>
              <td>张睿</td>
              <td>东平高级中学</td>
            </tr>
            <tr>
              <!-- <td>二等奖</td> -->
              <td>申家兴</td>
              <td>阳泉市第十五中学校</td>
            </tr>
            <tr>
              <!-- <td>一等奖</td> -->
              <td>高宇欣</td>
              <td>中阳县第一中学校</td>
            </tr>
            <tr>
              <td>刘蕊</td>
              <td>新源县第二中学</td>
            </tr>
            <tr>
              <td>刘艺</td>
              <td>东平高级中学</td>
            </tr>
            <tr>
              <td>韩泽坤</td>
              <td>山西省汾阳中学校</td>
            </tr>
            <tr>
              <td>张一涵</td>
              <td>山西省汾阳中学校</td>
            </tr>
            <tr>
              <td>张雨北</td>
              <td>山西省汾阳中学校</td>
            </tr>
            <tr>
              <td>李雨潼</td>
              <td>凌海市第二高级中学</td>
            </tr>
            <tr>
              <td>房婷婷</td>
              <td>梅州市曾宪梓中学</td>
            </tr>
            <tr>
              <td rowspan="15">三等奖</td>
              <td>王诺</td>
              <td>东平高级中学</td>
            </tr>
            <tr>
              <td>杨忻俣</td>
              <td>东平高级中学</td>
            </tr>
            <tr>
              <td>孙雨菡</td>
              <td>潍坊文昌中学</td>
            </tr>
            <tr>
              <td>李志浩</td>
              <td>东平高级中学</td>
            </tr>
            <tr>
              <td>荚爱华</td>
              <td>福建省清流县第一中学</td>
            </tr>
            <tr>
              <td>曲禹行</td>
              <td>宝清县第二高级中学</td>
            </tr>
            <tr>
              <td>安康</td>
              <td>东平高级中学</td>
            </tr>
            <tr>
              <td>任涛</td>
              <td>山西省汾阳中学校</td>
            </tr>
            <tr>
              <td>方雍童</td>
              <td>东莞外国语学校</td>
            </tr>
            <tr>
              <td>张礼栋</td>
              <td>山西省汾阳中学校</td>
            </tr>
            <tr>
              <td>辛成成</td>
              <td>东平高级中学</td>
            </tr>
            <tr>
              <td>胡瑛娜</td>
              <td>黑河市第一中学</td>
            </tr>
            <tr>
              <td>李舒涵</td>
              <td>潍坊文昌中学</td>
            </tr>
            <tr>
              <td>赵婉竹</td>
              <td>山西省汾阳中学校</td>
            </tr>
            <tr>
              <td>郭美娴</td>
              <td>佛山市顺德区郑裕彤中学</td>
            </tr>
            <tr>
              <td rowspan="20">四等奖</td>
              <td>余璐</td>
              <td>东莞外国语学校</td>
            </tr>
            <tr>
              <td>曹可心</td>
              <td>宝清县第一高级中</td>
            </tr>
            <tr>
              <td>蔡铭</td>
              <td>梅州市曾宪梓中学</td>
            </tr>
            <tr>
              <td>王静</td>
              <td>大连市一〇三中学</td>
            </tr>
            <tr>
              <td>李王赫</td>
              <td>东平高级中学</td>
            </tr>
            <tr>
              <td>孙娅涵</td>
              <td>山西省汾阳中学校</td>
            </tr>
            <tr>
              <td>王美清</td>
              <td>福建省清流县第一中学</td>
            </tr>
            <tr>
              <td>李奕金</td>
              <td>福建省清流县第一中学</td>
            </tr>
            <tr>
              <td>张心如</td>
              <td>山西省汾阳中学校</td>
            </tr>
            <tr>
              <td>杨璐</td>
              <td>山西省汾阳中学校</td>
            </tr>
            <tr>
              <td>舒贵豪</td>
              <td>福建省武夷山第一中学</td>
            </tr>
            <tr>
              <td>张琦</td>
              <td>东平高级中学</td>
            </tr>
            <tr>
              <td>尚亦佳</td>
              <td>东平高级中学</td>
            </tr>
            <tr>
              <td>牛万一</td>
              <td>东平高级中学</td>
            </tr>
            <tr>
              <td>吴一</td>
              <td>东平高级中学</td>
            </tr>
            <tr>
              <td>齐成宇</td>
              <td>东平高级中学</td>
            </tr>
            <tr>
              <td>杨静</td>
              <td>山西省汾阳中学校</td>
            </tr>
            <tr>
              <td>杨安宁</td>
              <td>甘肃省礼县第一中学</td>
            </tr>
            <tr>
              <td>吴晓彤</td>
              <td>东平高级中学</td>
            </tr>
            <tr>
              <td>杨红霞</td>
              <td>山西省汾阳中学校</td>
            </tr>
          </table>
        </div>
        <div style="margin-top: 10px" class="race-item-title-top">
          &nbsp;&nbsp;&nbsp;&nbsp; 再次恭喜以上获奖同学，所有获奖证书和奖品已寄出，如有疑问请咨询客服“知夏”（微信号：zljx_2）。获奖的同学们可以根据自己的名次，从以下奖品设置中获知自己的奖品哦！
        </div>
        <div style="margin-top: 10px" class="race-item-title-top">
          <h3>应用文（第一题）奖项设置：</h3>
        </div>
        <div>
          <img src="../assets/images/奖1.png" alt="" />
        </div>
        <div
          style="margin-top: 10px; margin-bottom: 10px"
          class="race-item-title-top"
        >
          <h3>读后续写（第二题）奖项设置：</h3>
        </div>
        <div>
          <img src="../assets/images/奖2.png" alt="" />
        </div>
        <div class="race-item-title-top">
          <p>注意：</p>
          &nbsp;&nbsp;1. 本次大赛最终得分为自动批改得分与人工复评综合得分；
          <br />
          &nbsp;&nbsp;2.
          人工复评过程中发现部分非原创作品，此类作品不享有获奖权限。
        </div>
      </div>
      <div class="race-item">
        <div class="race-item-title">简介</div>
        <div class="race-item-text">
          英语是高考必修科目，也是需要良好的语言积累的学科，其中作文是分值很大的一道题，考察学生的句法、用词、拼写、标点等综合语言书写能力，写得越多，语言就越准确。同时英语写作对阅读、听力、口语、翻译等各方面都有促进作用，在竞争激烈的高考中，将英语作文这一板块牢牢攥紧，硬核提升自然不在话下！
          <br />
          <br />
          而对于高考来说，今年有9个省针对语文、英语作文等主观性命题引入了机器阅卷，意味着对学生的卷面、书写、词语使用、语法的要求变高。
          <br />
          <br />
          为助力学生有效训练英语作文技巧，提高逻辑思考及分析问题的能力，培养良好的英语书写习惯和卷面意识，在英语作文自动批改功能上线之际，风向标教育特别举办知心慧学杯英语作文大赛，训练学生英语作文技巧的同时，体验人工智能即时批阅英语作文的神奇，有效把握高考作文分。
        </div>
      </div>
      <div class="race-item">
        <div class="race-item-title">参赛题目</div>
        <div class="race-item-icon">
          <div class="icon-left"></div>
          <div class="icon-student"></div>
          <span>第一题</span>
          <div class="icon-right"></div>
        </div>
        <div class="race-item-text first-font">
          假定你是李华，你校将为交换生举办一场名为“Cover Chinese songs in
          <br />
          English”的比赛。请用英文给在你校学习了3年的留学生朋友Peter写一封邮件，邀请他参赛。要点包括：
          <br />
          &nbsp;&nbsp;1. 简单介绍比赛目的；
          <br />
          &nbsp;&nbsp;2. 请Peter谈谈喜欢的中国偶像歌手；
          <br />
          &nbsp;&nbsp;3. 报名截止日期：6月20日。
          <br />
          注意：
          <br />
          1. 词数100左右；
          <br />
          2. 可以适当增加细节，以使行文连贯。
          <br />
          <br />
          <p>Dear Peter,</p>
          ________
          <p>Yours</p>
          <p>Li Hua</p>
        </div>
        <div class="race-item-icon mt">
          <div class="icon-left"></div>
          <div class="icon-student"></div>
          <span>第二题</span>
          <div class="icon-right"></div>
        </div>
        <div class="race-item-text race-font">
          读后续写（满分25分）
          <br />
          阅读下面短文，根据所给情节进行续写，使之构成一个完整的故事。
          <p>
            It was the first run of a family ski weekend in Colorado. It was a
            perfect spring morning, and the skies were cloudless. I was tired
            and considered opting out of the run. But the
            <u><b>kids</b></u> were <u><b>complaining</b></u> about attending
            ski school, and I figured I should push through — that if I skipped
            out, then they’d think that they could too.
          </p>
          <p>
            I <u><b>dropped</b></u> the kids at ski school, then I was fully
            prepared so I could chase my <u><b>friend</b></u
            >, and my husband, <u><b>Adam</b></u
            >, who were already off and running.
          </p>
          <p>
            I pushed off and caught up with my friend. My
            <u><b>legs</b></u> felt heavy; I debated, again, calling it a day.
            Then, three minutes into the run, my left ski came off; then my
            right ski inverted and took my leg with it, I remember seeing my ski
            careening（倾斜） toward me at an obscene angle, and then I heard
            the crack.
          </p>
          <p>
            I lay splattered on the snow, my leg distorted at a right angle to
            my body. My friend heard my shrieks and doubled back. A kind man
            stopped and phoned ski patrol. I was strapped onto a toboggan and
            taken down the mountain to an ambulance.
          </p>
          <p>
            I woke up after surgery with my leg bandaged beyond recognition,
            with tubes coming out of various limbs and my mind flighty and
            confused. I wouldn’t walk for three months, optimistically. I
            couldn’t drive. I couldn’t navigate the steps in our house. I
            couldn’t even shower on my own. I would sit in an
            <u><b>recovery</b></u> machine for six hours a day.
          </p>
          <p>
            Who would get the kids to the <u><b>bus</b></u> at 7:15 a.m., since
            my husband was in his office by 6 a.m. each day? Who would
            <u><b>deal with</b></u> the dogs, two rambunctious Labradors, who
            relied on my companionship and long walks? Who would prepare
            <u><b>dinner</b></u> ?
          </p>
          <p>
            “We’ll figure it out,” Adam said. I nodded, because what was the
            alternative? But in any of my mind did I believe him. Not even a
            tiny bit.
          </p>
          注意：
          <br />
          1. 所续写短文的词数应为150左右；
          <br />
          2. 至少使用5个短文中标有下划线的关键词语；
          <br />
          3. 续写部分分为两段，每段的开头语已为你写好；
          <br />
          <br />
          Paragraph 1:<br />
          I wrote each person back, thanking them all but not taking them up on
          their kind offers.
          <br />
          ________
          <br />
          Paragraph 2:
          <br />
          My kids learned to be both autonomous and considerate.
          <br />
          ________
          <br />
        </div>
      </div>
      <div class="race-item">
        <div class="race-item-title">参赛时间</div>
        <div class="race-item-text">
          <p>2021.1.29-2021.2.26（参赛通道开放）</p>
          <p>
            大赛获奖结果将于2021.3.5号后通过知心慧学教师端、学生端的英语作文大赛海报/微信公众号/微博/官方微信朋友圈等方式告知。
          </p>
        </div>
      </div>
      <div class="race-item">
        <div class="race-item-title">参赛方式</div>
        <div class="race-item-text">
          1.&nbsp;
          参赛者在应用文和读后续写两个题型中任选一个题型（或两个题型都参赛），进行手写英语作文，拍照或扫描后在规定时间内上传至自动批改系统。（作文题由江西风向标教育互联网教育研究院英语研究组按照高考命题标准命制，两个题型均有奖项设置，每个题型仅限上传一次，若选择两个题型都参赛，则需同时上传）
          <br />
          2.&nbsp;
          登录知心慧学学生端后点击英语作文大赛参赛入口海报，在规定时间内按步骤上传个人作文照片/扫描件，并填写正确的手机号（用来联系获奖者，寄送奖品）
          （注意：书写潦草或拍照光线不足的图片将无法识别，需要按照基本标准和要求重新书写后再次上传，请务必保证填写的参赛信息是真实有效的，否则视作无效作品。
        </div>
      </div>
      <div class="race-item">
        <div class="race-item-title">参赛要求</div>
        <div class="race-item-text">
          （1）命题作文有应用文和读后续写两个题型，参赛者可任选一个题型进行参赛，也可两个题型都参赛。（两个题型均有奖项设置，每个题型仅限上传一次，若选择两个题型都参赛，则需同时上传）
          <br />
          （2）参赛作文要求个人原创，内容要求符合审题标准，一旦发现抄袭，有权剥夺获奖权限。
          <br />
          （3）务必保证填写的参赛信息真实有效，否则视作无效作品；如果出现雷同卷，将按上传和打分时间综合判断最终结果。
          <br />
          （4）上传作品需确保书写工整、图片清晰。
          <br />
          <div class="race-example">
            <p>示例图如下：</p>
            <img src="../assets/images/race-example.png" alt="" />
          </div>
        </div>
      </div>
      <div class="race-item">
        <div class="race-item-title">成绩报告</div>
        <div class="race-item-text">
          <p>
            参赛者上传作品后，即可实时查看AI评分、智能点评与全国实时排名。最后经过英语研究组人工复评，给出最终获奖名单，并给出权威选拔评价，于结果日（2021.3.5）公布
          </p>
        </div>
      </div>
      <div class="race-item">
        <div class="race-item-title">奖励设置</div>
        <div class="race-item-text">
          <p class="hf">应用文奖项设置：</p>
          <p>一等奖1名，二等奖10名，三等奖15名，优秀奖20名。</p>
          <p>一等奖：颁发相关荣誉证书+礼品（苹果Ipad）</p>
          <p>二等奖：颁发相关荣誉证书+礼品（小米AI音箱）</p>
          <p>三等奖：颁发相关荣誉证书+礼品（家用静音加湿器）</p>
          <p>优秀奖：颁发相关荣誉证书+礼品（定制精美笔袋）</p>
          <br />
          <p class="hf">读后续写奖项设置：</p>
          <p>一等奖1名，二等奖10名，三等奖15名，优秀奖20名。</p>
          <p>一等奖：颁发相关荣誉证书+礼品（苹果Ipad）</p>
          <p>二等奖：颁发相关荣誉证书+礼品（小爱触屏音箱）</p>
          <p>三等奖：颁发相关荣誉证书+礼品（小米体脂称）</p>
          <p>优秀奖：颁发相关荣誉证书+礼品（定制精美笔袋）</p>
          <br />
          <p>
            获奖的所有作品将有机会做成英语作文优秀案例应用在知心慧学英语个性化学习宝当中，以图片的形式公布于“知心慧学”官方微博及“知了老师”、“知了家长”、“互联网教育风向标”微信公众号中。（作品一经收录，默认版权将归属我公司所有。）
          </p>
        </div>
      </div>
      <div class="race-item m0">
        <div class="race-item-title">其他</div>
        <div class="race-item-text">
          英语作文自动批改是基于AI智能分析，结合专业的英语规则，从内容相关度、句子和词汇、篇章结构、字数、书写规范等多维度进行打分，得出最专业的作文分数，并提供个性化的成绩报告和分析指导。
          <br />
          英语作文自动批改亮点：
          <br />
          1. 评分维度丰富；
          <br />
          2. 评语生动且个性化；
          <br />
          3. 按句点评，错误各个击破；
          <br />
          4. 亮词亮句点评，充分挖掘学生亮点
          <br />
          5. 作文写作万能模板推荐，为学生奉上写作宝典
          <br />
          知心慧学英语作文自动批改，更细致，更多维，更精准！只为让学生更精准有效提高英语写作水平！
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="less">
.race-wrapper {
  margin: 0 auto;
  max-width: 1200px;
  padding: 15px 0 0;
  font-family: "Times New Roman";
  .race-top {
    width: 100%;
    background-image: url("../assets/images/race-banner.png");
    background-size: contain;
    height: 300px;
    margin-bottom: 10px;
  }
  .race-content {
    background: #fff;
    border: 4px solid #202636;
    border-radius: 20px;
    box-shadow: 0 0 20px 0 #e2e7f2;
    padding: 20px 24px;
    .race-item {
      text-align: center;
      margin-bottom: 40px;
      .race-item-title {
        display: inline-block;
        width: 183px;
        height: 36px;
        background-image: url("../assets/images/race-box.png");
        background-size: 100% 100%;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        margin-bottom: 20px;
      }
      .tab-mhk {
        margin: 0 auto;
        td {
          text-align: center;
        }
      }
      .race-item-title-mhk {
        display: inline-block;
        width: 350px;
        // height: 36px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        margin-bottom: 20px;
        margin-top: 20px;
        background-size: contain;
      }
      .race-item-title-top {
        font-size: 20px;
        text-align: left;
        width: 575px;
        margin-left: 286px;
      }
      .mt {
        margin-top: 20px;
      }
      .race-item-icon {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        span {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #4379fe;
        }
        .icon-left,
        .icon-student,
        .icon-right {
          width: 16px;
          height: 4px;
          background-size: cover;
        }

        .icon-left {
          //   background-image: url("../../assets/imgs/race-left.png");
          margin-right: 6px;
        }
        .icon-right {
          //   background-image: url("../../assets/imgs/race-right.png");
          margin-left: 8px;
        }
        .icon-student {
          height: 16px;
          //   background-image: url("../../assets/imgs/race-student.png");
          margin: 0 2px;
        }
      }
      .race-item-text {
        text-align: left;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        .hf {
          font-size: 18px;
          font-weight: 600;
        }
        .race-example {
          margin-top: 20px;
          text-align: center;
          img {
            display: block;
            width: 599px;
            height: 600px;
            border: 1px solid #dddddd;
            margin: 10px auto;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// race.vue?44b7deae